import { bySport } from "./sportFunctions.ts";

// This might not be comprehensive. It was first made for teamStats, and then later used in comparePlayers.
export const lowerIsBetter = new Set(
	bySport({
		baseball: [
			"lost",
			"otl",
			"cs",
			"so",
			"gdp",
			"l",
			"era",
			"bs",
			"rPit",
			"er",
			"hPit",
			"2bPit",
			"3bPit",
			"hrPit",
			"bbPit",
			"pc",
			"ibbPit",
			"hbpPit",
			"shPit",
			"sfPit",
			"bk",
			"wp",
			"bf",
			"fip",
			"whip",
			"h9",
			"hr9",
			"bb9",
			"pc9",
			"oppPa",
			"oppAb",
			"oppPts",
			"oppH",
			"opp2b",
			"opp3b",
			"oppHr",
			"oppRbi",
			"oppSb",
			"oppBb",
			"oppBa",
			"oppObp",
			"oppSlg",
			"oppOps",
			"oppTb",
			"oppHbp",
			"oppSh",
			"oppSf",
			"oppIbb",
			"oppMov",
			"oppCg",
			"oppSho",
			"oppSv",
			"oppIp",
			"oppSoPit",
			"oppBf",
			"oppSow",
		],
		basketball: [
			"lost",
			"otl",
			"tov",
			"pf",
			"oppFg",
			"oppFga",
			"oppFgp",
			"oppTp",
			"oppTpa",
			"oppTpp",
			"opp2p",
			"opp2pa",
			"opp2pp",
			"oppFt",
			"oppFta",
			"oppFtp",
			"oppOrb",
			"oppDrb",
			"oppTrb",
			"oppAst",
			"oppStl",
			"oppBlk",
			"oppPts",
			"oppMov",
			"pl",
			"drtg",
			"tovp",
			"oppFgAtRim",
			"oppFgaAtRim",
			"oppFgpAtRim",
			"oppFgLowPost",
			"oppFgaLowPost",
			"oppFgpLowPost",
			"oppFgMidRange",
			"oppFgaMidRange",
			"oppFgpMidRange",
			"oppDd",
			"oppTd",
			"oppQd",
			"oppFxf",
			"oppEfg",
			"oppFtpFga",
		],
		football: [
			"lost",
			"otl",
			"tov",
			"fmb",
			"fmbLost",
			"pssInt",
			"pssIntPct",
			"pssSk",
			"pssSkYds",
			"pssSkPct",
			"pen",
			"penYds",
			"drivesTurnoverPct",
			"pntBlk",
			"skAlw",
			"skAlwPct",
			"oppPts",
			"oppYds",
			"oppPly",
			"oppYdsPerPlay",
			"oppPssCmp",
			"oppPss",
			"oppPssYds",
			"oppPssTD",
			"oppPssNetYdsPerAtt",
			"oppRus",
			"oppRusYds",
			"oppRusTD",
			"oppRusYdsPerAtt",
			"oppDrives",
			"oppDrivesScoringPct",
			"oppAvgFieldPosition",
			"oppTimePerDrive",
			"oppPlaysPerDrive",
			"oppYdsPerDrive",
			"oppPtsPerDrive",
			"oppMov",
			"oppCmpPct",
			"oppPssTDPct",
			"oppPssLng",
			"oppPssYdsPerAtt",
			"oppPssAdjYdsPerAtt",
			"oppPssYdsPerCmp",
			"oppPssYdsPerGame",
			"oppQbRat",
			"oppPssAdjNetYdsPerAtt",
			"oppRusLng",
			"oppRusYdsPerGame",
			"oppRusPerGame",
			"oppDefInt",
			"oppDefIntYds",
			"oppDefIntTD",
			"oppDefIntLng",
			"oppDefPssDef",
			"oppDefFmbFrc",
			"oppDefFmbRec",
			"oppDefFmbYds",
			"oppDefFmbTD",
			"oppDefFmbLng",
			"oppDefSk",
			"oppDefTck",
			"oppDefTckSolo",
			"oppDefTckAst",
			"oppDefTckLoss",
			"oppDefSft",
			"oppPen",
			"oppPenYds",
			"oppFg0",
			"oppFga0",
			"oppFg20",
			"oppFga20",
			"oppFg30",
			"oppFga30",
			"oppFg40",
			"oppFga40",
			"oppFg50",
			"oppFga50",
			"oppFgLng",
			"oppFg",
			"oppFga",
			"oppFgPct",
			"oppXp",
			"oppXpa",
			"oppXpPct",
			"oppKickingPts",
			"oppKo",
			"oppKoYds",
			"oppKoYdsPerAtt",
			"oppKoTB",
			"oppKoTBPct",
			"oppOk",
			"oppOkRec",
			"oppOkRecPct",
			"oppPnt",
			"oppPntYds",
			"oppPntYdsPerAtt",
			"oppPntLng",
			"oppPntIn20",
			"oppPntTB",
			"oppPr",
			"oppPrYds",
			"oppPrTD",
			"oppPrLng",
			"oppPrYdsPerAtt",
			"oppKr",
			"oppKrYds",
			"oppKrTD",
			"oppKrLng",
			"oppKrYdsPerAtt",
			"oppAllPurposeYds",
			"oppRecTD",
			"oppAllTD",
			"oppTp",
			"oppTpa",
			"oppPtsPerGame",
			"oppPbw",
			"oppPba",
			"oppPbwr",
			"oppRbw",
			"oppRba",
			"oppRbwr",
		],
		hockey: [
			"lost",
			"otl",
			"pim",
			"fol",
			"gv",
			"ga",
			"gaa",
			"oppG",
			"oppA",
			"oppEvG",
			"oppPpG",
			"oppShG",
			"oppEvA",
			"oppPpA",
			"oppShA",
			"oppS",
			"oppSPct",
			"oppTsa",
			"oppPpo",
			"oppPpPct",
			"oppFow",
			"oppFoPct",
			"oppBlk",
			"oppHit",
			"oppTk",
			"oppSv",
			"oppSvPct",
			"oppSo",
			"oppMov",
		],
	}),
);
